<div style="text-align: center; margin-top: 10px; margin-bottom: 10px; padding: 0 10px 0 10px;">
    <b>Hulp nodig bij uw aanvraag? Bel naar 088 0120 282 of stuur een mail naar Sales@we-id.nl</b>
</div>